import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const ComingSoonCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  max-width: 860px;
  margin: 3rem auto;
  padding: 3.5rem 3rem;
  background-color: white;
  border-radius: 0.75rem;
  border: 1px solid var(--colour-border-neutral-lightest, #e5e9ed);
  box-shadow: 0 2px 8px rgba(34, 43, 51, 0.06);
`

export const ComingSoonIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: var(--colour-fill-action-lightest, #d6e1ff);
  margin-bottom: 0.5rem;
`

export const ComingSoonTitle = styled.div`
  ${font('2xl', 'bold')}
  color: var(--colour-text-primary, #222b33);
`

export const ComingSoonSubtitle = styled.div`
  ${font('base', 'regular')}
  color: var(--colour-text-secondary, #607890);
  max-width: 520px;
`

export const ComingSoonMetricsRow = styled.div`
  display: flex;
  column-gap: 1rem;
  margin-top: 1.25rem;
`

export const ComingSoonMetricGhost = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 160px;
  height: 96px;
  border-radius: 0.5rem;
  background-color: var(--colour-fill-neutral-lightest, #f2f4f6);
  opacity: 0.7;
`

export const ComingSoonMetricGhostBar = styled.div`
  width: 64px;
  height: 10px;
  border-radius: 4px;
  background-color: var(--colour-border-neutral-lightest, #d0d6db);
`
